<script lang="ts" setup></script>
<template>
  <span
    class="d-flex align-center justify-center bg-primary-container rounded-sm opacity-100 mt-n1"
    :style="{
      backgroundColor: 'rgb(var(--v-theme-primary-container))',
      width: '24px',
      height: '32px',
      marginTop: '2px !important',
    }"
  >
    <v-icon icon="mdi-unfold-more-horizontal" size="24px" />
  </span>
</template>
<style scoped lang="scss"></style>
